module.exports = __webpack_public_path__ + "img/15.4da97851.jpg";